/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 16L16 8M8 8L16 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27605 2.65396C6.55953 2 8.23968 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V12.4C22 15.7603 22 17.4405 21.346 18.7239C20.7708 19.8529 19.8529 20.7708 18.7239 21.346C17.4405 22 15.7603 22 12.4 22H11.6C8.23968 22 6.55953 22 5.27605 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M8 16L12 12M12 12L16 8M12 12L8 8M12 12L16 16M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23968 2 6.55953 2 5.27605 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27605 21.346C6.55953 22 8.23968 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75H10.85C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39709 2.4792 4.52606 1.90396ZM8.53033 7.46967C8.23744 7.17677 7.76257 7.17677 7.46967 7.46967C7.17678 7.76256 7.17678 8.23743 7.46967 8.53033L10.9393 12L7.46967 15.4697C7.17678 15.7626 7.17678 16.2374 7.46967 16.5303C7.76257 16.8232 8.23744 16.8232 8.53033 16.5303L12 13.0607L15.4697 16.5303C15.7626 16.8232 16.2374 16.8232 16.5303 16.5303C16.8232 16.2374 16.8232 15.7626 16.5303 15.4697L13.0607 12L16.5303 8.53033C16.8232 8.23743 16.8232 7.76256 16.5303 7.46967C16.2374 7.17677 15.7626 7.17677 15.4697 7.46967L12 10.9393L8.53033 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C8.07116 2 7.60674 2 7.21684 2.05133C4.52444 2.40579 2.40579 4.52444 2.05133 7.21684C2 7.60674 2 8.07116 2 9L2 12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2V2L14.5 2M8 16L12 12M12 12L16 8M12 12L8 8M12 12L16 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 16L12 12M12 12L16 8M12 12L8 8M12 12L16 16M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L12 10.9393L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L13.0607 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L12 13.0607L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L10.9393 12L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
